import axios from 'axios';
import store from '@/store';
import { getUser, updateToken } from '@/services/tokenStore';
import { getClientIdentity } from '@/utils/clientIdentity';

axios.interceptors.request.use((config) => {
    try {
        config.headers = config.headers || {};
        const identity = getClientIdentity();
        if (identity.kind) {
            config.headers['x-client-kind'] = identity.kind;
        }
        if (identity.version) {
            config.headers['x-client-version'] = identity.version;
        }
        if (identity.build) {
            config.headers['x-client-build'] = identity.build;
        }
        if (identity.model) {
            config.headers['x-device-model'] = identity.model;
        }
        if (identity.manufacturer) {
            config.headers['x-device-manufacturer'] = identity.manufacturer;
        }
        const user = getUser();
        if (user?.token) {
            config.headers.token = user.token;
        }
    } catch (err) {
        // ignore malformed storage
    }
    return config;
});

function persistRenewedToken(headers) {
    const newToken = headers?.['x-access-token'];
    if (!newToken) {
        return;
    }
    try {
        updateToken(newToken);
    } catch (err) {
        // ignore malformed storage
    }
}

axios.interceptors.response.use(
    (response) => {
        persistRenewedToken(response.headers);
        return response;
    },
    (error) => {
        if (error?.response?.status === 401) {
            store.dispatch('auth/logout').catch(() => {});
            if (typeof window !== 'undefined' && window.location.pathname !== '/portal/login') {
                window.location.assign('/portal/login');
            }
        }
        return Promise.reject(error);
    },
);

export default axios;
